export interface ImportRecord {
  id: string
  fileName: string
  kindLabel: string
  dateLabel: string
  created: number
}

export const importHistory: ImportRecord[] = [
  {
    id: 'IMP-3',
    fileName: 'sphere-export-july.csv',
    kindLabel: 'Leads & past clients',
    dateLabel: 'Jul 06, 2026 · 9:12 AM',
    created: 214,
  },
  {
    id: 'IMP-2',
    fileName: 'agent-partners-q2.csv',
    kindLabel: 'Realtors & partners',
    dateLabel: 'Jul 06, 2026 · 9:04 AM',
    created: 61,
  },
  {
    id: 'IMP-1',
    fileName: 'top-producer-list.csv',
    kindLabel: 'Realtor prospects',
    dateLabel: 'Jun 22, 2026 · 4:41 PM',
    created: 44,
  },
]
